import * as type from './type'
import util from 'common/js/util';

export default {
    [type.GET_AGREEMENT](context, option) {
        util.post({
            params: {
                functionId: "getRegisterAgreement",
            },
            sc(data) {
                if (option && option.sc) {
                    option.sc(data);
                }
            },
            fc(data) {
                if (option && option.fc) {
                    option.fc(data);
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/store/agreement/actions.js